module.exports = __webpack_public_path__ + "img/06_uk.70804aea.svg";